import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { containerVariants, textVariants, imageVariants } from '../script/animation';

const NedenGenesis = () => {
    const { t } = useTranslation();

    return (
        <motion.div className='space-y-20 pb-20'>
            {/* Banner */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full bg-red grid grid-cols-11 relative min-h-[30vh]'>
                
                <motion.img variants={imageVariants} src='/images/general-banner.jpg' className='w-full h-full object-cover absolute' />

                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-9 z-50 py-20 grid grid-cols-1 md:grid-cols-2 md:gap-10 lg:gap-20 content-start'>
                    <div className='text-white'>
                        <motion.h1 variants={textVariants} className='text-65 font-bold nunito-sans mb-5'>
                            {t('neden_genesis_title')}
                        </motion.h1>
                    </div>
                </div>
            </motion.div>

            {/* Güvenilirlik ve Zamanında Teslimat */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full grid grid-cols-11 relative bg-white'>
                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50'>
                    <motion.h2 variants={textVariants} className='text-genesisBlue text-45 mb-3'>
                        {t('guvenilirlik_zamaninda_teslimat')}
                    </motion.h2>
                    <motion.p variants={textVariants} className='text-customGray text-18'>
                        {t('guvenilirlik_zamaninda_teslimat_text')}
                    </motion.p>
                </div>
            </motion.div>

            {/* Tecrübeli ve Uzman Kadro */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full grid grid-cols-11 relative bg-white'>
                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50'>
                    <motion.h2 variants={textVariants} className='text-genesisBlue text-45 mb-3'>
                        {t('tecrubeli_uzman_kadro')}
                    </motion.h2>
                    <motion.p variants={textVariants} className='text-customGray text-18'>
                        {t('tecrubeli_uzman_kadro_text')}
                    </motion.p>
                </div>
            </motion.div>

            {/* Yüksek Donanım ve Modern Altyapı */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full grid grid-cols-11 relative bg-white'>
                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50'>
                    <motion.h2 variants={textVariants} className='text-genesisBlue text-45 mb-3'>
                        {t('yuksek_donanim_modern_altyapi')}
                    </motion.h2>
                    <motion.p variants={textVariants} className='text-customGray text-18'>
                        {t('yuksek_donanim_modern_altyapi_text')}
                    </motion.p>
                </div>
            </motion.div>

            {/* Entegre Lojistik Çözümleri */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full grid grid-cols-11 relative bg-white'>
                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50'>
                    <motion.h2 variants={textVariants} className='text-genesisBlue text-45 mb-3'>
                        {t('entegre_lojistik_cozumleri')}
                    </motion.h2>
                    <motion.p variants={textVariants} className='text-customGray text-18'>
                        {t('entegre_lojistik_cozumleri_text')}
                    </motion.p>
                </div>
            </motion.div>

            {/* Sektörlere Özel Hizmet Anlayışı */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full grid grid-cols-11 relative bg-white'>
                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50'>
                    <motion.h2 variants={textVariants} className='text-genesisBlue text-45 mb-3'>
                        {t('sektorlere_ozel_hizmet')}
                    </motion.h2>
                    <motion.p variants={textVariants} className='text-customGray text-18'>
                        {t('sektorlere_ozel_hizmet_text')}
                    </motion.p>
                </div>
            </motion.div>

            {/* Müşteri Odaklı Hizmet */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full grid grid-cols-11 relative bg-white'>
                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50'>
                    <motion.h2 variants={textVariants} className='text-genesisBlue text-45 mb-3'>
                        {t('musteri_odakli_hizmet')}
                    </motion.h2>
                    <motion.p variants={textVariants} className='text-customGray text-18'>
                        {t('musteri_odakli_hizmet_text')}
                    </motion.p>
                </div>
            </motion.div>

        </motion.div>
    );
}

export default NedenGenesis;
